let inFlightPromise = null;
let lastGetTokenFn = null;

/**
 * Gets a Clerk token with in-flight de-duping.
 *
 * Why: multiple components often call `getToken()` simultaneously on mount, which
 * can trigger Clerk's `/tokens` endpoint rate limiting (429). This helper ensures
 * only one in-flight token request exists.
 */
export async function getClerkToken(getToken) {
  if (getToken && lastGetTokenFn && getToken !== lastGetTokenFn) {
    inFlightPromise = null;
  }
  if (getToken) {
    lastGetTokenFn = getToken;
  }

  if (inFlightPromise) {
    return inFlightPromise;
  }

  inFlightPromise = (async () => {
    return await getToken?.();
  })().finally(() => {
    inFlightPromise = null;
  });

  return inFlightPromise;
}
